import type { PlanTier } from '../types'

const PLAN_FEATURES = {
  maxCards:         { free: 1,     pro: Infinity, casal: Infinity },
  historyMonths:    { free: 3,     pro: Infinity, casal: Infinity },
  categoryLimits:   { free: false, pro: true,     casal: true     },
  householdSharing: { free: false, pro: false,    casal: true     },
  ai_scanner:       { free: false, pro: true,     casal: true     },
  whatsapp_bot:     { free: false, pro: true,     casal: true     },
} as const

type Feature = keyof typeof PLAN_FEATURES
type FeatureValue<F extends Feature> = typeof PLAN_FEATURES[F][PlanTier]

export function can<F extends Feature>(feature: F, plan: PlanTier): FeatureValue<F> {
  return PLAN_FEATURES[feature][plan] as FeatureValue<F>
}
